import { render, staticRenderFns } from "./StatisticValue.vue?vue&type=template&id=15a468d6&"
import script from "./StatisticValue.vue?vue&type=script&lang=js&"
export * from "./StatisticValue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports